import React from 'react';
import { useNavigate } from 'react-router-dom';

const characters = [
  {
    id: 'valentino',
    name: 'Valentino',
    subtitle: 'Italian Businessman',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face',
  },
  {
    id: 'sophia',
    name: 'Sophia',
    subtitle: 'Art Curator',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face',
  },
  {
    id: 'marcus',
    name: 'Marcus',
    subtitle: 'Tech Entrepreneur',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face',
  },
  {
    id: 'elena',
    name: 'Elena',
    subtitle: 'Travel Blogger',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face',
  },
];

function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900 via-purple-800 to-pink-700">
      <div className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-white text-center mb-2">FunChats</h1>
        <p className="text-purple-200 text-center mb-8">Choose a character to chat with</p>

        <div className="space-y-4">
          {characters.map((character) => (
            <button
              key={character.id}
              onClick={() => navigate(`/chat/${character.id}`)}
              className="w-full bg-white/10 backdrop-blur-sm rounded-2xl p-4 flex items-center gap-4 hover:bg-white/20 transition-all active:scale-98"
            >
              <img
                src={character.avatar}
                alt={character.name}
                className="w-16 h-16 rounded-full object-cover border-2 border-pink-400"
              />
              <div className="text-left">
                <h2 className="text-white font-semibold text-lg">{character.name}</h2>
                <p className="text-purple-200 text-sm">{character.subtitle}</p>
              </div>
              <div className="ml-auto">
                <svg className="w-6 h-6 text-pink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
